import { TopModel } from 'core/api/home/useApiGetTeamLastFourWeeksPerformance'
import { VpIcon, VpSticker } from '@vtmn-play/react'
import { ComponentType, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormatNumber } from 'core/hooks/useFormatNumber'
import { useFormatAmount } from 'core/hooks/useFormatAmount'

type ProductModelCardProps = {
  model: TopModel
  stickerLabel: string
  currency: string
}

const Sticker = VpSticker as ComponentType<{
  id: string
  children: ReactNode
  variant: 'neutral'
  size: 'small'
}>

const ProductModelCard = ({ model, stickerLabel, currency }: ProductModelCardProps) => {
  const { t } = useTranslation()
  const formatAmount = useFormatAmount()
  const formatNumber = useFormatNumber()

  return (
    <div className="mg-last-four-weeks-product-card">
      <div className="mg-last-four-weeks-product-picture">
        {model.pictureUrl && <img src={model.pictureUrl} alt="" />}
        {!model.pictureUrl && (
          <div className="mg-last-four-weeks-product-picture-fallback-icon">
            <VpIcon {...({ name: 'image', size: 24 } as any)} />
          </div>
        )}
        <div className="mg-last-four-weeks-product-sticker">
          <Sticker id={`top-model-${model.modelId}-sticker`} variant="neutral" size="small">
            {stickerLabel}
          </Sticker>
        </div>
      </div>
      <div className="mg-last-four-weeks-product-details">
        <div className="mg-last-four-weeks-product-description">
          {model.name && <div className="mg-last-four-weeks-product-name vp-body-s">{model.name}</div>}
          <div className="mg-last-four-weeks-product-id vp-caption">ID {model.modelId}</div>
        </div>
        <div className="mg-last-four-weeks-product-kpis vp-body-m">
          {formatAmount(model.gmv, currency)}
          <span className="mg-last-four-weeks-product-divider" aria-hidden="true" />
          <span>
            {t('homepage.last-four-weeks-team-performance.quantity')}: {formatNumber(model.quantity)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProductModelCard
